import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const VesselSelectWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 55px;
  margin-left: 30px;
  margin-right: 30px;

  &.home-marina-mobile-vessel-select {
    min-height: 40px;
  }

  .ant-select {
    .ant-select-selector {
      border-color: transparent;
      padding: 0;
      &:hover {
        border-color: transparent;
      }
      .ant-select-selection-item {
        color: ${themeGet('text.4', '#323232')};
        font-size: 20px;
        font-weight: bold;
      }
    }
    &.ant-select-focused:not(.ant-select-disabled) {
      .ant-select-selector {
        border-color: transparent;
        box-shadow: none;
        outline: none;
      }
    }
    .ant-select-arrow {
      top: 32%;
      width: 20px;
      height: 20px;
    }
    &.ant-select-single.ant-select-show-arrow {
      .ant-select-selection-item {
        padding-right: 30px;
      }
    }
    &.ant-select-disabled {
      .ant-select-selector {
        background-color: ${themeGet('color.1', '#ffffff')};
        cursor: default;
      }
    }
  }
`;
